import { render } from "./MigrateVolume.vue?vue&type=template&id=6668ed12&scoped=true"
import script from "./MigrateVolume.vue?vue&type=script&lang=js"
export * from "./MigrateVolume.vue?vue&type=script&lang=js"

import "./MigrateVolume.vue?vue&type=style&index=0&id=6668ed12&scoped=true&lang=scss"

import exportComponent from "/jenkins/workspace/acs-centos7-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.19.1.2/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6668ed12"]])

export default __exports__